
<footer class="bg-gray-900 text-white py-12">
  <div class="max-w-7xl mx-auto px-6">
    <!-- Footer Sections -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
      <!-- Contact Info -->
      <!--<div>
        <h3 class="text-2xl font-serif text-gold mb-4">Get In Touch With Us</h3>
        <p class="text-gray-300 mb-2">Phone: +212 6 02 91 06 25</p>
&lt;!&ndash;        <p>&ndash;&gt;
&lt;!&ndash;          <a href="mailto:info@andre-abt.com" class="text-gold hover:text-gold-dark transition duration-300">@.com</a>&ndash;&gt;
&lt;!&ndash;        </p>&ndash;&gt;
        <div class="flex space-x-4 mt-4">
          <a href="#" class="text-white bg-gold bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 transition duration-300">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
            </svg>
          </a>
          <a href="#" class="text-white bg-gold bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 transition duration-300">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
            </svg>
          </a>
          <a href="#" class="text-white bg-gold bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 transition duration-300">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 4.4 2.86 8.13 6.84 9.45.5.09.68-.22.68-.48v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.52 2.34 1.08 2.91.83.09-.65.35-1.08.63-1.33-2.22-.25-4.56-1.11-4.56-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.29.1-2.68 0 0 .84-.27 2.75 1.03A9.56 9.56 0 0112 6.8c.85.004 1.7.114 2.5.33 1.9-1.3 2.74-1.03 2.74-1.03.55 1.39.2 2.43.1 2.68.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.67.93.67 1.87v2.77c0 .27.18.58.69.48A9.963 9.963 0 0022 12c0-5.5-4.46-9.96-9.96-9.96z"></path>
            </svg>
          </a>
          <a href="#" class="text-white bg-gold bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 transition duration-300">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12c0 4.41 2.87 8.14 6.84 9.49.5.09.68-.22.68-.49v-1.71c-2.78.61-3.37-1.34-3.37-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.61.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.52 2.34 1.08 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.56-1.11-4.56-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.29.1-2.68 0 0 .84-.27 2.75 1.03A9.56 9.56 0 0112 6.8c.85.004 1.7.114 2.5.33 1.9-1.3 2.74-1.03 2.74-1.03.55 1.39.2 2.43.1 2.68.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.67.93.67 1.87v2.77c0 .27.18.58.69.48A9.963 9.963 0 0022 12c0-5.5-4.46-9.96-9.96-9.96z"></path>
            </svg>
          </a>
        </div>
      </div>-->



      <!-- About Us -->
    <!--  <div>
        <h3 class="text-2xl font-serif text-gold mb-4">About Us</h3>
        <ul class="space-y-2">
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">About the Shop</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Our Story</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Services</a></li>
        </ul>
      </div>-->

      <!-- Account & Shipping Info -->
<!--
      <div>
        <h3 class="text-2xl font-serif text-gold mb-4">Account & Shipping Info</h3>
        <ul class="space-y-2">
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Your Account</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Shipping Rates & Policies</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Refunds & Replacements</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Taxes</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Delivery Info</a></li>
          <li><a href="#" class="text-gray-300 hover:text-gold transition duration-300">Affiliate Program</a></li>
        </ul>
      </div>
-->
    </div>

    <!-- Divider -->
    <hr class="border-gray-700 my-8">

    <!-- Payment Methods -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
      <div class="max-w-[615px]">
        <img src="img/payment_methods.png" alt="Payment Methods" class="w-full">
      </div>
      <div></div>
    </div>

    <!-- Copyright -->
    <p class="text-gray-400 text-center">
      © All rights reserved. Made with
      <svg class="w-4 h-4 inline-block text-gold" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
      </svg>
      <a href="https://www.linkedin.com/in/khalid-errabiy-654146214/" target="_blank" class="text-gold hover:text-gold-dark transition duration-300">by Errabiy Khalid</a>
    </p>
  </div>
</footer>
